module.exports = __webpack_public_path__ + "static/img/build.afff0ba4.svg";